export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/evernote-8e04f24a8013fe52d0851ce14713ab2a.png";